import styled from 'styled-components/native';

import {
  H2,
  H4,
  IconButton,
  LargePrimaryButton,
  P2,
  P3,
  PrimaryDivider,
} from '../../../base_ui';
import { moderateScale } from '../../../../utils/scaleHelpers';

export const BiWeeklyContentContainer = styled.View`
  flex: 1;
  padding: ${moderateScale(8)}px 0 ${moderateScale(24)}px;
`;

export const BiWeeklyHeadingContainer = styled.View`
  padding: 0 ${moderateScale(24)}px ${moderateScale(23)}px;
`;

export const BiWeeklyInfoSectionWrapper = styled.View`
  margin: 0 ${moderateScale(24)}px;
`;

export const BoldText = styled.Text`
  font-family: ${({ theme: { fontFamilies: { secondaryFontBold } } }) => secondaryFontBold};
`;

export const FlexContainer = styled.View`
  flex: 1;
`;

export const SelectButtonWrapper = styled.View`
  background-color: ${({ theme: { colors: { dmiWhite } } }) => dmiWhite};
`;

export const SelectCardContent = styled.View`
  flex: 1;
  padding: ${moderateScale(8)}px 0 ${moderateScale(35)}px 0;
  text-align: left;
`;

export const SelectRowContainer = styled.View`
  align-items: center;
  flex-direction: row;
  padding:
    ${moderateScale(12)}px ${moderateScale(15)}px ${moderateScale(12)}px ${moderateScale(14)}px;
`;

export const SelectTextContainer = styled.View`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: ${moderateScale(14)}px;
`;

export const SemiMonthlyButtonWrapper = styled.View`
  margin-top: ${moderateScale(16)}px;
  text-align: center;
`;

export const SemiMonthlyCardContent = styled.View`
  flex: 1;
  padding: ${moderateScale(8)}px ${moderateScale(24)}px ${moderateScale(24)}px;
  text-align: left;
`;

export const SemiMonthlyFormContainer = styled.View`
  flex: 1;
  margin-top: ${moderateScale(8)}px;
`;

export const SemiMonthlyFormItemHeading = styled(H4)`
  margin: ${moderateScale(16)}px 0;
`;

export const SemiMonthlyRowContainer = styled.View`
  align-items: center;
  flex-direction: row;
  margin: ${moderateScale(3)}px 0 ${moderateScale(3)}px ${moderateScale(-10)}px;
`;

export const SemiMonthlyRowLabel = styled.Text`
  padding-left: ${moderateScale(3)}px;
`;

export const StyledDivider = styled(PrimaryDivider)`
  max-width: 100%;
`;

export const StyledH2 = styled(H2)`
  margin-bottom: ${moderateScale(4)}px;
`;

export const StyledIconButton = styled(IconButton)`
  align-self: center;
`;

export const StyledLargePrimaryButton = styled(LargePrimaryButton)`
  align-self: center;
  height: ${moderateScale(45)}px;
  margin: ${moderateScale(21)}px auto ${moderateScale(35)}px;
`;

export const StyledP2 = styled(P2)`
  margin: ${moderateScale(4)}px 0;
`;

export const StyledP3 = styled(P3)`
  font-variant-numeric: diagonal-fractions;
`;

export const StyledText = styled.Text`
  line-height: ${moderateScale(22)}px;
`;
